<template>
  <div :style="{ 'background-color': $vuetify.theme.themes.light.backgroundHome }">
    <HomeCadu @reloadHeader="$emit('reloadHeader')" ref="homeCadu"/>
  </div>
</template>

<script>
import HomeCadu from '../components/HomeCadu/HomeCadu'

export default {
  components: {
    HomeCadu
  },
  beforeMount () {
    localStorage.removeItem('ultimaPesquisa')

    this.$emit('loadDados')
  }
}
</script>
